// Description: Request to edit one campaign
// Updated: 21/08/2025
// Author: Simon Franklin

export async function CampaignUpdate(campaignData) {
    try {
        const token = localStorage.getItem('jwt_token');
        const clientId = localStorage.getItem('idToken');

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!clientId) throw new Error('ID do cliente não encontrado');

        const response = await fetch(`${process.env.REACT_APP_BACKEND_AWS_URL}/campaigns/schedule/edit`,
            {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    'Client_ID': `${clientId}`
                },
                body: JSON.stringify(campaignData)
            }
        );

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Error saving campaign data:', error);
        throw new Error('Error saving campaign data');
    }
}